import {
  BreakAwayPreview,
  ChangeCostCenterSeatsRequest,
  ChangeCostCenterSeatsResponse,
  CheckoutUrlResponse,
  CostCenterDetailResponse,
  CostCenterListResponse,
  UpdateCostCenterRequest,
} from './generated'
import { fetchAPI } from '.'

export async function listCostCenters(enterpriseId: string) {
  return fetchAPI<CostCenterListResponse>({
    method: 'GET',
    url: `/api/v1/enterprise/${encodeURIComponent(enterpriseId)}/cost-centers`,
  })
}

export async function getCostCenter(costCenterId: string) {
  return fetchAPI<CostCenterDetailResponse>({
    method: 'GET',
    url: `/api/v1/cost-centers/${encodeURIComponent(costCenterId)}`,
  })
}

export async function createCostCenter(enterpriseId: string) {
  return fetchAPI<CostCenterDetailResponse>({
    method: 'POST',
    url: `/api/v1/enterprise/${encodeURIComponent(enterpriseId)}/cost-centers`,
    data: {},
  })
}

export async function createCostCenterBilling(costCenterId: string) {
  return fetchAPI<CheckoutUrlResponse>({
    method: 'POST',
    url: `/api/v1/cost-centers/${encodeURIComponent(costCenterId)}/billing`,
    data: {},
  })
}

/** Change members' seat types. A retry must resend the same request_id and changes, or it may buy twice. */
export async function changeCostCenterSeats(costCenterId: string, data: ChangeCostCenterSeatsRequest) {
  return fetchAPI<ChangeCostCenterSeatsResponse>({
    method: 'POST',
    url: `/api/v1/cost-centers/${encodeURIComponent(costCenterId)}/seat-changes`,
    data,
    // 503 (outcome unknown) stays reported: it is a real signal, not a normal flow.
    expectedStatuses: [409, 429],
  })
}

/** Rename a cost center. Enterprise admins only. */
export async function updateCostCenter(costCenterId: string, data: UpdateCostCenterRequest) {
  return fetchAPI<CostCenterDetailResponse>({
    method: 'PATCH',
    url: `/api/v1/cost-centers/${encodeURIComponent(costCenterId)}`,
    data,
  })
}

/** Delete an inactive cost center. Used to clean up after a cancelled break-away. */
export async function deleteCostCenter(costCenterId: string) {
  return fetchAPI<void>({
    method: 'DELETE',
    url: `/api/v1/cost-centers/${encodeURIComponent(costCenterId)}`,
  })
}

/** Pre-checkout summary for a break-away (team name, source CC, member counts, price math). */
export async function getBreakAwayPreview(costCenterId: string) {
  return fetchAPI<BreakAwayPreview>({
    method: 'GET',
    url: `/api/v1/cost-centers/${encodeURIComponent(costCenterId)}/break-away-preview`,
  })
}
